import can from 'can';
import BaseWidget from 'scripts/base-widget';

export const RolexClock = BaseWidget.extend({
    init: function() {
        this.viewModel = {
            iframe: this.options.iframe,
        };

        this.view = can.stache(`
            <div class="m-rolex-clock__content">
                {{{iframe}}}
            </div>
        `);
        this._super();
    },
});
